import { render, staticRenderFns } from "./receptiondata.vue?vue&type=template&id=7fc110a8&scoped=true"
import script from "./receptiondata.vue?vue&type=script&lang=js"
export * from "./receptiondata.vue?vue&type=script&lang=js"
import style0 from "./receptiondata.vue?vue&type=style&index=0&id=7fc110a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc110a8",
  null
  
)

export default component.exports